module.exports = __webpack_public_path__ + "media/images/TheInformationLogo-23232826.png";